var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManyAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0005 20C40.0005 31.046 31.0465 40 20.0005 40C8.95489 40 0.000488281 31.046 0.000488281 20C0.000488281 8.9542 8.95489 0 20.0005 0C31.0465 0 40.0005 8.9542 40.0005 20Z",
    fill: "#222F49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5005 20C39.5005 30.7699 30.7703 39.5 20.0005 39.5C9.23102 39.5 0.500488 30.7699 0.500488 20C0.500488 9.23035 9.23103 0.5 20.0005 0.5C30.7703 0.5 39.5005 9.23034 39.5005 20Z",
    stroke: "url(#paint0_radial_1329_31202)",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1329_31202",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.000488212 -0.585223) rotate(45.4161) scale(56.9839 71.3139)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9DA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465568"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManyAssets);
export default __webpack_public_path__ + "static/media/manyAssets.682f8a8e6e83cf207fc736d50f1b004f.svg";
export { ForwardRef as ReactComponent };